<template>
  <div class="gmb-attribute-item" v-if="service">
    <GmbServiceChip
      :name="service.display_name"
      :value="service.value"
      :description="service.description"
      :delete-mode="deleteMode"
      toggle-only
      @add-description="$emit('add-description', service)"
      @input="selectValue"
    />
  </div>
</template>

<script>
import GmbServiceChip from "@/components/FacilityDetails/GmbServices/GmbServiceMassChip.vue";

export default {
  name: "GmbServicesItemBool",
  components: {
    GmbServiceChip
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    selectValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>
